var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('to-top',{staticClass:"totop"}),_vm._v(" "),(!_vm.isMobile)?_c('Support'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }